import "./ProductionsPage.css";
import HeaderImage from "../../assets/images/main_header.jpg";
import {Anchor, Breadcrumb } from "antd";
import {Link, useNavigate} from "react-router-dom";
import MelImage from "../../assets/images/mel.jpg";

const ProductionsPage = () => {

    const nav = useNavigate();

    const productionsData = {
        part1: [
            {
                key: '1',
                product: 'МТП-1',
                link: "MTP-1"
            },
            {
                key: '2',
                product: 'МТП-2',
                link: "MTP-2"
            },
            {
                key: '3',
                product: 'МДП-1',
                link: "MDP-1",
            },
            {
                key: '4',
                product: 'МДП-2',
                link: "MDP-2"
            },
            {
                key: '5',
                product: 'ММЖП',
                link: "MMGP"
            },
            {
                key: '6',
                product: "Мел, сырье для производства комбикормов",
                link: "kormovoyMel"
            }
        ],
        // part2: [
        //     {
        //         key: '1',
        //         product: 'ММЖП-1',
        //         link: "MMGP-1"
        //     }
        // ]
    }


    return(
        <div className="productions-container">
            <div className={"productions-container-image"}>
                <img src={HeaderImage} alt="Header Background" style={{width: "100%"}}/>
            </div>

            <div className={"productions-header"}>
                <h1>Продукция</h1>
                <Breadcrumb className="productions-header-breadcrumb"
                    items={[
                        {
                            title: <Link to="/">Главная страница</Link>
                        },
                        {
                            title: <span>Продукция</span>,
                        },
                    ]}
                />
                <div className="under-breadcrumb-divider"></div>
            </div>

            <div className={"productions-content"}>
                <div className="productions-content-anchor">
                    <Anchor
                        items={[
                            {
                                key: 'part-1',
                                href: '#part-1',
                                title: 'Мел природный сухомолотый',
                            },
                            // {
                            //     key: 'part-2',
                            //     href: '#part-2',
                            //     title: "Мел минерального происхождения",
                            // },
                        ]}
                    />
                </div>


                <div className={"productions-content-parts"}>
                    <div className={"productions-content-part"} id={"part-1"}>
                        <h2 className="production-part-title">Мел природный сухомолотый</h2>
                        <div className="products-grid">
                            {productionsData.part1.map((item) => (
                                <div
                                    className="product-card"
                                    key={item.key}
                                    onClick={() => nav("/" + item.link)}
                                >
                                    <div className="product-image">
                                        <img src={MelImage}/>
                                    </div>
                                    <div className="product-info">
                                        <h3 className="product-name">{item.product}</h3>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default ProductionsPage;